export const initialState = {
  authorizations: [],
  page: {},
  links: {},
  loadingAuthorizations: false,
  error: {},
  errorAlert: false,
  newAuthorization: {
    sponsors: [],
    type: {},
    error: {},
    sponsorForm: {},
    beneficiarySearch: {
      isAllowBeneficiaryDataUpdate: false,
      sponsorSlug: null,
      formSlug: null,
      inputs: []
    },
    steps: {
      type: false,
      sponsor: false,
      method: false,
      beneficiary: false,
      beneficiarySearchComplete: false
    },
    navBarType: '',
    actualStep: 1,
    providerProducts: [],
    providerProductTypes: [],
    biometricVerificationRequired: true,
    sponsorDocumentPolicy: []
  },
  prescription: {},
  beneficiaries: [],
  beneficiarySelected: {},
  beneficiary: {},
  loadingVerification: false,
  loadingCreateClaim: false,
  createClaimError: {},
  biometricVerificationResult: {},
  authorizationResult: null,
  authorizationFormValues: {
    beneficiaryFields: {},
    doctorFields: {},
    isVerified: null,
    requirements: undefined
  },
  authorizationDetail: {
    header: {},
    detail: {},
    attachedFile: {},
    sponsorProduct: {}
  },
  dialogAuthorizationFilesAttach: false,
  prescriptionCreated: false,
  dispensing: {
    document: null,
    error: null,
    loading: false
  },
  dispensation: {
    loading: {
      general: false,
      creation: false
    },
    error: {},
    cosharings: {},
    dispensationResult: null
  },
  filters: [],
  providerName: null,
  providerLegalName: null,
  biometricVerificationMethod: null,
  sponsorTransactionCoverageTypeRequirementsError: null,
  sponsorsProvider: null
}

export default {
  ...initialState
}
